/* eslint-disable camelcase */
import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist/src/constants';
import { pushNotificationStatus } from 'common/constants/options';
import requestStatus from 'common/constants/status';
import { camelCaseKeys } from 'common/utils/general';
import {
  getStoredThemeMode,
  storeThemeMode,
  normalizeThemeMode
} from 'common/theme/themeMode';

const initialState = {
  config: {
    language: 'es',
    miniDrawer: false,
    pushNotifications: pushNotificationStatus.default,
    // Modo de tema: leído síncronamente del espejo local para evitar flash al arrancar.
    themeMode: getStoredThemeMode()
  },
  status: requestStatus.idle
};

// Toggle del usuario (updateSuccess): el valor entrante ES el recién guardado, así que manda.
const reconcileThemeMode = (incoming, current) => {
  const mode = normalizeThemeMode(incoming?.themeMode || current || getStoredThemeMode());
  storeThemeMode(mode);
  return mode;
};

// Carga inicial tras login (findSuccess): el TEMA DEL DISPOSITIVO (espejo local) manda sobre lo
// guardado en backend → "si inicio con light, todo light". El backend NO pisa el tema al loguear.
const preserveLocalThemeMode = (current) => {
  const mode = normalizeThemeMode(current || getStoredThemeMode());
  storeThemeMode(mode);
  return mode;
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    create(state) {
      state.status = requestStatus.loading;
    },
    createSuccess(state) {
      state.status = requestStatus.success;
    },
    createError(state) {
      state.status = requestStatus.error;
    },
    find(state) {
      state.status = requestStatus.success;
    },
    findSuccess(state, action) {
      const next = camelCaseKeys(action.payload);
      next.themeMode = preserveLocalThemeMode(state.config.themeMode);
      state.config = next;
      state.status = requestStatus.success;
    },
    findError(state) {
      state.status = requestStatus.error;
    },
    update(state) {
      state.status = requestStatus.loading;
    },
    updateSuccess(state, action) {
      const next = camelCaseKeys(action.payload);
      next.themeMode = reconcileThemeMode(next, state.config.themeMode);
      state.config = next;
      state.status = requestStatus.success;
    },
    updateError(state) {
      state.status = requestStatus.error;
    },
    // Cambio inmediato del modo (toggle sol/luna). Actualiza Redux + espejo local al
    // instante; la persistencia en backend la dispara el componente con `update`.
    setThemeMode(state, action) {
      const mode = normalizeThemeMode(action.payload);
      storeThemeMode(mode);
      state.config.themeMode = mode;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

export default settingsSlice;
